import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Crumb from './Crumb';

const HomeCrumb = ({ href }) => (
  <Crumb href={href} position={1} label={trans('breadcrumb.label.home')} />
);

HomeCrumb.propTypes = {
  href: PropTypes.string.isRequired
};

export default HomeCrumb;
